<!--
 * @Author: jiaoxiaojie jiaoxiaojie666@sina.com
 * @Date: 2023-11-21 13:58:42
 * @LastEditors: jiaoxiaojie jiaoxiaojie666@sina.com
 * @LastEditTime: 2023-11-21 15:32:45
 * @FilePath: \main\src\views\Notauth.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="notpageauth">
    <el-empty :image-size="300" description="您暂无访问权限，可以联系管理员配置。">
      <el-button type="primary" style="margin-left:5px" @click="goindex()">返回首页</el-button>
</el-empty>
  </div>
</template>

<script>
export default {
  name: 'notpageauth',
  mounted () {

  },
  methods: {
    goindex () {
      window.open(
        window.location.protocol + '//' + window.location.host,
        '_self'
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.notpageauth {
}
</style>
